import React from "react"
import { useTranslation } from "react-i18next"
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap"

import AddCandidatesModal from "./AddCandidatesModal"

const UploadNationalIdModal = ({ isOpen, toggle, trigger }) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      className=""
      backdrop="static"
    >
      <ModalHeader toggle={toggle}>{t("Generate Contracts")}</ModalHeader>
      <ModalBody>
        <AddCandidatesModal toggle={toggle} selectedUuid="" trigger={trigger} />
      </ModalBody>
    </Modal>
  )
}

export default UploadNationalIdModal
